import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { MeteringConceptMeterFieldsResponse } from "../Meter.types";

export const meteringConceptMeterQueries = {
  detail: (meterId?: number) =>
    queryOptions<MeteringConceptMeterFieldsResponse>({
      queryKey: ["meteringConceptMeter", { meterId }],
      queryFn: meterId ? () => fetchMeteringConceptMeter(meterId) : skipToken,
      enabled: typeof meterId !== "undefined",
      refetchInterval: false,
      refetchOnWindowFocus: false
    })
};

export function useMeteringConceptMeter(meterId?: number) {
  return useQuery(meteringConceptMeterQueries.detail(meterId));
}

async function fetchMeteringConceptMeter(meterId: number) {
  const response =
    await apiWithoutCamelization.get<MeteringConceptMeterFieldsResponse>(
      urls.apiWithoutCamelization.meteringConceptMeter(meterId)
    );
  return response.data;
}
